import { TThunkAction } from '../../types/redux';
import {
  COMPLAIN_REQUEST,
  COMPLAIN_COMPLAINTS_FETCHED,
  COMPLAIN_FAIL_REQUEST,
  IComplainRequest,
  IComplainFailRequest,
} from '../../constants/actionTypes/complain';
import { Action } from 'redux';
import { createGetComplaints } from '../../api';
import { IComplaint } from '../../types/complain';
import { proccessGetComplaintsError, checkCategoriesIds, proccessComplaints } from '../../utils/complain';

export type TComplainComplaintsFetched = 'complain/complaintsFetched';

export interface IComplainComplaintsFetched extends Action<TComplainComplaintsFetched> {
  offerId: number;
  complaints: IComplaint[];
  type: TComplainComplaintsFetched;
}

export interface IGetComplaintsParameters {
  offerCategoriesIds: number[];
  regionId?: number | null;
  offerId: number;
}

export function getComplaints({ offerCategoriesIds, regionId, offerId }: IGetComplaintsParameters): TThunkAction {
  return (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const error = checkCategoriesIds(offerCategoriesIds, offerId, logger);

    if (error) {
      dispatch<IComplainFailRequest>({
        offerId,
        error,
        type: COMPLAIN_FAIL_REQUEST,
      });
    }

    const categoryId = offerCategoriesIds[offerCategoriesIds.length - 1];

    dispatch<IComplainRequest>({ type: COMPLAIN_REQUEST, offerId });

    const getComplaintsFn = createGetComplaints(httpApi);

    return getComplaintsFn(categoryId, regionId)
      .then(complaintsRaw => {
        const complaints = proccessComplaints(complaintsRaw);
        dispatch<IComplainComplaintsFetched>({
          offerId,
          complaints,
          type: COMPLAIN_COMPLAINTS_FETCHED,
        });
      })
      .catch(reason => {
        const error = proccessGetComplaintsError(reason, logger);
        dispatch<IComplainFailRequest>({
          offerId,
          error,
          type: COMPLAIN_FAIL_REQUEST,
        });
      });
  };
}
